import React, { useState } from 'react'
import './Export.css'
import { FcDownload } from "react-icons/fc";
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadOutlined';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const downloadFile = ({ data, fileName, fileType }) => {
  // Create a blob with the data we want to download as a file
  const blob = new Blob([data], { type: fileType })
  // Create an anchor element and dispatch a click event on it
  // to trigger a download
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

const exportToJson = (e,data) => {
  e.preventDefault()
  downloadFile({
    data: JSON.stringify(data),
    fileName: 'PatientData.json',
    fileType: 'text/json',
  })
}

const exportToCsv = (e,data) => {
    e.preventDefault()
  
    // Headers for each column
    let headers = ['id,first_name,last_name,email,gender,cancer,genetype,gene,enterTreatment,selection,line']
  
    // Convert users data to a csv
    let usersCsv = data.reduce((acc, user) => {
      const {id,first_name,last_name,email,gender,cancer,genetype,gene,enterTreatment,selection,line} = user
      acc.push([id,first_name,last_name,email,gender,cancer,genetype,gene,enterTreatment,selection,line].join(','))
      return acc
    }, [])
  
    downloadFile({
      data: [...headers, ...usersCsv].join('\n'),
      fileName: 'Patient_Data.csv',
      fileType: 'text/csv',
    })
  }

function ExportFeature(data,flag) {

  return (<>
      {flag &&
        <Button  title="Export Data" onClick={e =>exportToCsv(e,data)}>
        <FileDownloadRoundedIcon  fontSize="large"/>
        </Button>}
      </>
  )
}

export default ExportFeature